export default {
  apiVersion: 'v2022-05-01',
  dataset: import.meta.env.PUBLIC_SANITY_DATASET,
  projectId: import.meta.env.PUBLIC_SANITY_PROJECT_ID,
  useCdn: true,
};
